import React from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';

const CallStagesFlowSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{ flex: 1, position: 'relative' }}>
      {/* Control Buttons Skeleton - Top Right */}
      <Box
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          zIndex: 1000,
          display: 'flex',
          gap: 1,
        }}
      >
        <Skeleton
          variant="rectangular"
          width={80}
          height={40}
          sx={{ borderRadius: '6px' }}
        />
        <Skeleton
          variant="rectangular"
          width={120}
          height={40}
          sx={{ borderRadius: '6px' }}
        />
      </Box>

      {/* Flow Canvas Background */}
      <Box
        sx={{
          width: '100%',
          height: '100%',
          backgroundColor: theme.palette.secondary.main,
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Simple Loading Content */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          {/* Main Skeleton Nodes */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Skeleton
              variant="rectangular"
              width={200}
              height={100}
              sx={{
                borderRadius: '8px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              }}
            />
            <Skeleton
              variant="rectangular"
              width={200}
              height={100}
              sx={{
                borderRadius: '8px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              }}
            />
          </Box>

          {/* Single bottom node */}
          <Skeleton
            variant="rectangular"
            width={200}
            height={100}
            sx={{
              borderRadius: '8px',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            }}
          />
        </Box>

        {/* Background Grid Pattern */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `
              linear-gradient(rgba(0, 0, 0, 0.05) 1px, transparent 1px),
              linear-gradient(90deg, rgba(0, 0, 0, 0.05) 1px, transparent 1px)
            `,
            backgroundSize: '20px 20px',
            opacity: 0.3,
            zIndex: -1,
          }}
        />
      </Box>

      {/* ReactFlow Controls Skeleton - Bottom Left (Zoom In/Out, Fit View, etc.) */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 16,
          left: 16,
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            backgroundColor: 'white',
            borderRadius: '8px',
            p: 1,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(0, 0, 0, 0.05)',
          }}
        >
          {/* Zoom In Button */}
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            sx={{ borderRadius: '4px' }}
          />
          {/* Zoom Out Button */}
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            sx={{ borderRadius: '4px' }}
          />
          {/* Fit View Button */}
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            sx={{ borderRadius: '4px' }}
          />
          {/* Interactive Button */}
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            sx={{ borderRadius: '4px' }}
          />
        </Box>
      </Box>

      {/* Mini Map Skeleton - Bottom Right */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 16,
          right: 16,
          zIndex: 1000,
        }}
      >
        <Skeleton
          variant="rectangular"
          width={120}
          height={80}
          sx={{
            borderRadius: '8px',
            backgroundColor: 'white',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(0, 0, 0, 0.05)',
          }}
        />
      </Box>
    </Box>
  );
};

export default CallStagesFlowSkeleton;
